import { render, staticRenderFns } from "./DumbappModal.vue?vue&type=template&id=284a4ada&scoped=true&"
import script from "./DumbappModal.vue?vue&type=script&lang=js&"
export * from "./DumbappModal.vue?vue&type=script&lang=js&"
import style0 from "./DumbappModal.vue?vue&type=style&index=0&id=284a4ada&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a4ada",
  null
  
)

export default component.exports